import { NavDropdown } from 'react-bootstrap'
import React from 'react'
import { Link } from 'react-router-dom'
import routes from '../routes'

export default function AdminNav(props) {

  return (
    <NavDropdown alignRight id="sb-nav-admin" className="no-carrot" title="Admin">
      <NavDropdown.Item as={Link} to={`${routes.bucketsPath}`}>
        Buckets
      </NavDropdown.Item>
    </NavDropdown>
  )
}